import React from "react";
import { Checkbox } from "@mui/material";
import { AppTheme } from "../../../theme/App.theme";

const MuiCheckBox = ({
  Color,
  ClassName,
  Style,
  SX,
  Indeterminate,
  Checked,
  OnChange,
  OnBlur,
  IsDefaultChecked,
  Value,
  Name,
  Id,
  Disabled
}) => {

  const isDefaultChecked = IsDefaultChecked ? { defaultChecked: IsDefaultChecked } : {}
  return (
    <Checkbox
      style={{ ...Style }}
      disabled={Disabled || false}
      className={ClassName}
      value={Value}
      name={Name}
      id={Id}
      indeterminate={Indeterminate}
      checked={Checked}
      onChange={OnChange}
      onBlur={OnBlur}
      sx={{
        color: Color || AppTheme.PRIMARY_COLOR,
        padding: '8px', // Example of overriding padding
        '&.MuiButtonBase-root': {
          color: `${Color || AppTheme.RESET_BUTTON_COLOR} !important`,
          padding: '8px !important', // Ensure your padding isn't overridden
        },
        '&.Mui-checked': {
          color: `${Color || AppTheme.PRIMARY_COLOR} !important`,
        },
        '&.MuiCheckbox-indeterminate': {
          color: `${Color || AppTheme.PRIMARY_COLOR} !important`,
        },
        '&.Mui-disabled': {
          color: `${Color || AppTheme.RESET_BUTTON_COLOR} !important`,
        },
        ...SX,
      }}
      {...isDefaultChecked}
    />
  );
};

export default MuiCheckBox;
